var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClassificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3555 16.1457L8.07922 12.2277C7.38965 11.8564 7.37522 10.8724 8.0536 10.4811L15.3303 6.28294C15.6346 6.1074 16.0086 6.10438 16.3157 6.27497L23.8718 10.4728C24.569 10.8601 24.5545 11.8676 23.8465 12.2347L16.2899 16.153C15.9964 16.3052 15.6466 16.3024 15.3555 16.1457Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8584 16.396L14.9867 21.1375C15.2827 21.3102 15.6466 21.3192 15.9509 21.1615L25.1414 16.396",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 21.415L14.9831 26.1656C15.2815 26.3327 15.6447 26.3357 15.9458 26.1735L24.783 21.415",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassificationIcon);
export default __webpack_public_path__ + "static/media/classification-icon.c839d86969addd25d9d2e0714afbabc6.svg";
export { ForwardRef as ReactComponent };